/**
 * Bot döngüsünün 5 saniyelik tik kaynağı.
 *
 * NEDEN: Chromium (dolayısıyla Electron) gizli/örtülü penceredeki `setInterval`
 * ve `setTimeout`'u dakikada bire kadar kısar ("intensive wake-up throttling").
 * 9 Eyl 2026 HAR kaydı: imza penceresi arkadayken 30 sn'lik heartbeat dakikada
 * bir attı, next-task 3 dakika hiç sorulmadı; 15:54'e planlı paket 15:57'de
 * başladı. Web Worker içindeki zamanlayıcı bu kısıtlamaya girmez ve ana iş
 * parçacığına gönderdiği mesaj hemen işlenir; bu yüzden tik bir Worker'dan
 * gelir. Worker kurulamıyorsa (jest/jsdom, kısıtlı CSP, eski kabuk)
 * `setInterval`'e düşülür — davranış aynı, yalnız kısılma koruması yok.
 *
 * Saf tutuldu: `Worker` yapıcısı dışarıdan verilebilir (test), sonuç `durdur()`
 * ile kapatılır. Tik aralığı çağıranın; döngü mantığı burada değil.
 */
export interface TikZamanlayiciKolu {
    durdur(): void;
    /** Tanı: "worker" ya da "interval". */
    kaynak: "worker" | "interval";
}

export type WorkerFabrikasi = (kaynakKodu: string) => {
    onmessage: ((e: unknown) => void) | null;
    terminate(): void;
} | null;

function varsayilanWorkerFabrikasi(kaynakKodu: string) {
    const W = (typeof Worker !== "undefined" ? Worker : null) as any;
    const U = (typeof URL !== "undefined" && typeof (URL as any).createObjectURL === "function") ? URL : null;
    const B = (typeof Blob !== "undefined" ? Blob : null) as any;
    if (!W || !U || !B) {
        return null;
    }
    try {
        const url = (U as any).createObjectURL(new B([kaynakKodu], {type: "application/javascript"}));
        const w = new W(url);
        // Blob URL yalnız kurulumda gerekir; hemen bırakılabilir.
        try { (U as any).revokeObjectURL(url); } catch (_) { /* önemsiz */ }
        return w;
    } catch (_) {
        return null;
    }
}

export function tikZamanlayiciKur(
    aralikMs: number,
    tik: () => void,
    workerFabrikasi: WorkerFabrikasi = varsayilanWorkerFabrikasi
): TikZamanlayiciKolu {
    const kod = "setInterval(function(){ postMessage(0); }, " + Math.max(100, Math.floor(aralikMs)) + ");";
    let worker: ReturnType<WorkerFabrikasi> = null;
    try {
        worker = workerFabrikasi(kod);
    } catch (_) {
        worker = null;
    }
    if (worker) {
        worker.onmessage = () => tik();
        const w = worker;
        return {kaynak: "worker", durdur: () => { try { w.terminate(); } catch (_) { /* önemsiz */ } }};
    }
    const handle = setInterval(tik, aralikMs);
    return {kaynak: "interval", durdur: () => clearInterval(handle)};
}
